import logo from "./assets/logo-mainservice-new.png";
import facebookIcon from "./assets/facebook-menu.png";
import instagramIcon from "./assets/instagram-menu.png";
import linkedinIcon from "./assets/linkedin-menu.png";

export default function Header() {
  return (
    <header className="bg-white shadow-md fixed top-0 left-0 right-0 z-50">
      <div className="max-w-4xl mx-auto px-4 py-2 flex items-center justify-between">
        <a href="https://www.mainservice.com.br/" className="flex items-center gap-3 pl-2">
          <img src={logo} alt="MainService Logo" className="h-12" />
        </a>
        <nav className="hidden md:flex items-center gap-4 text-gray-800 text-sm font-medium">
          <a href="https://www.mainservice.com.br/sobre/" className="hover:text-teal-600">Quem somos</a>
          <a href="https://www.mainservice.com.br/servicos/" className="hover:text-teal-600">Serviços</a>
          <a href="https://www.mainservice.com.br/blog/" className="hover:text-teal-600">Blog</a>
          <a href="/" className="bg-orange-600 text-white px-3 py-1 rounded font-semibold hover:bg-orange-700">Abrir Chamado</a>
          <a href="https://www.mainservice.com.br/contato/" className="bg-orange-600 text-white px-3 py-1 rounded hover:bg-orange-700">Entre em Contato</a>
          <div className="flex gap-2 ml-3">
            <a href="https://www.facebook.com/mainserviceassistencia">
              <img src={facebookIcon} alt="Facebook" className="h-5 w-5" />
            </a>
            <a href="https://www.instagram.com/mainserviceassistencia/">
              <img src={instagramIcon} alt="Instagram" className="h-5 w-5" />
            </a>
            <a href="https://www.linkedin.com/company/mainserviceassistencia/">
              <img src={linkedinIcon} alt="LinkedIn" className="h-5 w-5" />
            </a>
          </div>
        </nav>
      </div>
    </header>
  );
}
